import React from 'react';
import { MdHomeFilled } from 'react-icons/md';
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoNotificationsSharp } from 'react-icons/io5';
import { useDefaultBottomBar } from './useDefaultBottomBar';
import { BottomBarProps } from './BottomBar';
import { Icon } from '@design-system';

export const DefaultBottomBar: React.FC<BottomBarProps> = ({ showMenu, setShowMenu }) => {
    const { handleNavigateToHome, handleNavigateToNotifications, unseenNotificationCount } = useDefaultBottomBar(setShowMenu);

    return (
        <div className="bottom-bar">
            <div className="item" onClick={handleNavigateToHome}>
                <Icon icon={<MdHomeFilled />} size={30} />
            </div>
            <div className="item" onClick={() => setShowMenu((prevShowMenu) => !prevShowMenu)}>
                <Icon icon={<GiHamburgerMenu />} size={30} color={showMenu ? 'green' : 'grey'} />
            </div>
            <div className="item" onClick={handleNavigateToNotifications}>
                <Icon icon={<IoNotificationsSharp />} size={30} />
                <span className="notification-count">{unseenNotificationCount}</span>
            </div>
        </div>
    );
};
